function getCookie1005(name) {
    let cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
        if (name == cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return undefined;
}
function get_ap_vid(ap_vid) {
  ap_vid=ap_vid || getCookie1005("ap_vid") || ("AP"+Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
  document.cookie =  'ap_vid=' + ap_vid + ';path=/;  domain=.paragonfishoil.com; ';
    return new Promise(function (resolve, reject) {
        let data1 = JSON.stringify({
            "visitor_id": ap_vid,
            "context": {
            },
            "trigger_hit": true,
            "decision_group": null
        });
        let xhr1 = new XMLHttpRequest();
        xhr1.open("POST", "https://decision.flagship.io/v2/c2rnmgek23k3filetdg0/campaigns/PFOT01?mode=simple");
        xhr1.setRequestHeader("content-type", "application/json");
        xhr1.setRequestHeader("x-api-key", "t95eI24trZ5YZhQYPlmwCxFtOYcB2K19wY4NFtJc");
        xhr1.onload = function () {
            if (xhr1.status == 200) {
                resolve(xhr1.responseText);
            } else {
                reject(status);
            }
        };
        xhr1.send(data1);
    });
}
function send_ap_pageview(ap_vid){
    ap_vid=ap_vid || getCookie1005("ap_vid");
    //if(!ap_vid) return undefined;
    return new Promise(function (resolve, reject) {
        let data1 = JSON.stringify({
            "cid": "c2rnmgek23k3filetdg0",
            "dl": document.location.href,
            "t": "PAGEVIEW",
            "vid": ap_vid,
            "ds":"APP"
        });
        let xhr1 = new XMLHttpRequest();
        xhr1.open("POST", "https://ariane.abtasty.com");
        xhr1.setRequestHeader("content-type", "application/json");
        xhr1.onload = function () {
            if (xhr1.status == 200) {
                resolve(xhr1.responseText);
            } else {
                reject(status);
            }
        };
        xhr1.send(data1);
    });
}

function send_ap_transaction(ap_vid){
  ap_vid=ap_vid || getCookie1005("ap_vid");
  if(!ap_vid) return undefined;
  return new Promise(function (resolve, reject) {
      let data1 = JSON.stringify({
          "cid": "c2rnmgek23k3filetdg0",
          "icn": 12,
          "pm": "Paypal",
          "sm": "Fedex",
          "t": "TRANSACTION",
          "ta": "Original transaction",
          "tc": "USD",
          "tcc": "Coupon",
          "tid": window?.Shopify?.Checkout?.token || ap_vid,
          "tr": 175,
          "ts": 0,
          "tt": 0,
          "vid": ap_vid,
          "ds": "APP"
      });
      let xhr1 = new XMLHttpRequest();
      xhr1.open("POST", "https://ariane.abtasty.com");
      xhr1.setRequestHeader("content-type", "application/json");
      xhr1.onload = function () {
          if (xhr1.status == 200) {
              resolve(xhr1.responseText);
          } else {
              reject(status);
          }
      };
      xhr1.send(data1);
  });
}
function get_branch(){
  return window?.E1020a?.variation?.modifications?.value?.key;
}
async function E1020(){
  let E1020a=await get_ap_vid();
  let E1020d=await send_ap_pageview();
  if(window.location.href.includes("/processing") && (localStorage.lastFconversion==undefined || ((new Date).getTime()-window.lastFconversion>20*60*1000)  ) ){
    localStorage.lastFconversion=(new Date).getTime();
    let E1020r= await send_ap_transaction();
    //console.log(E1020r);
    window.E1020r= (E1020r);
  }
  //console.log(E1020a);
  //console.log(E1020d);
  window.E1020a=JSON.parse(E1020a);
  window.E1020d= (E1020d);

  if(document.location.pathname.includes(get_branch())){
  }else{
    console.log(get_branch())
    //modify the url by line below
    window.location = document.location.href.replace("paragonfishoil.com","paragonfishoil.com"+'/'+get_branch());
    //placeholder by line below, toggle
    //window.location=window.location+"#"+get_branch();
  }

}
//E1020();

// to determine branch use get_branch() edited by swu
